export const datHangNcc = {
  sections: {
    list: { title: 'Đặt hàng nhà cung cấp' },
    detail: { title: 'Chi tiết đặt hàng NCC' },
  },
  titles: { add: 'Tạo phiếu đặt hàng' },
  columns: {
    code: 'Mã phiếu',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    nhaCungCap: 'Nhà cung cấp',
    ngayDat: 'Ngày đặt',
    ngayNhapDuKien: 'Ngày nhập dự kiến',
    tongTienHang: 'Tổng tiền hàng',
    maPhieuNhapKho: 'Phiếu nhập kho',
  },
  filter: { searchPlaceholder: 'Tìm theo mã / ghi chú...' },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Dùng ô tìm kiếm để lọc nhanh.',
  },
  status: {
    phieuTam: 'Phiếu tạm',
    daXacNhanNCC: 'Đã xác nhận NCC',
    nhapMotPhan: 'Nhập một phần',
    hoanThanh: 'Hoàn thành',
    daHuy: 'Đã hủy',
  },
  form: {
    supplier: 'Nhà cung cấp',
    code: 'Mã đặt hàng',
    codeAuto: 'Để trống tự sinh mã',
    orderDate: 'Ngày đặt',
    expectedDate: 'Ngày nhập dự kiến',
    trangThai: 'Trạng thái',
    phiVanChuyen: 'Phí vận chuyển',
    tienNCCTraLai: 'Tiền NCC trả lại',
    giamGiaPhieu: 'Giảm giá phiếu',
    giamGiaPhanTram: 'Giảm giá (%)',
    giamGiaHieuLuc: 'Giảm giá áp dụng',
    note: 'Ghi chú',
    lines: 'Hàng đặt mua',
    addLine: 'Thêm dòng',
    product: 'Hàng hóa',
    productName: 'Tên hàng hóa',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'Số lượng',
    unitPrice: 'Đơn giá',
    discount: 'Giảm giá',
    discountPercent: 'Giảm (%)',
    editDiscount: 'Cài đặt giảm giá',
    byAmount: 'Theo số tiền',
    byPercent: 'Theo phần trăm',
    currency: '₫',
    lineNote: 'Ghi chú dòng',
    lineAmount: 'Thành tiền',
    tongTienHang: 'Tổng tiền hàng',
    tienTraNcc: 'Tiền trả NCC',
    canTraNCC: 'Cần trả NCC',
    datHangNhap: 'Đặt hàng nhập',
    thanhToan: 'Thanh toán',
    phuongThucThanhToan: 'Phương thức thanh toán',
    tienMat: 'Tiền mặt',
    the: 'Thẻ',
    chuyenKhoan: 'Chuyển khoản',
    xong: 'Xong',
    titleTienTraNcc: 'Tiền trả nhà cung cấp',
  },
  validation: {
    supplierRequired: 'Vui lòng chọn nhà cung cấp',
    soLuongInvalid: 'Dòng {row} ({name}): số lượng phải lớn hơn 0',
    donGiaInvalid: 'Dòng {row} ({name}): đơn giá không được âm',
    expectedBeforeOrder: 'Ngày nhập dự kiến không được trước ngày đặt',
  },
  messages: {
    loadError: 'Không tải được danh sách.',
    deleteSuccess: 'Đã xóa phiếu.',
    createSuccess: 'Đã tạo phiếu đặt hàng.',
    updateSuccess: 'Đã cập nhật phiếu đặt hàng.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng.',
    noData: 'Không có phiếu đặt hàng.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} phiếu',
    confirmDelete: 'Xóa phiếu {name}?',
    copySuccess: 'Đã sao chép phiếu đặt hàng.',
    completeSuccess: 'Đã kết thúc phiếu đặt hàng.',
    cancelSuccess: 'Đã hủy phiếu đặt hàng.',
    importSuccess: 'Nhập hàng hóa thành công.',
  },
  actions: {
    copy: 'Sao chép',
    createPhieuNhan: 'Tạo phiếu nhận',
    complete: 'Kết thúc',
    cancelVoucher: 'Hủy phiếu',
    importExcel: 'Nhập Excel',
    downloadTemplate: 'Tải file mẫu',
  },
  fields: {
    totalAmount: 'Tổng tiền',
  },
  placeholders: {
    formTitle: 'Tạo / sửa đặt hàng NCC',
    formBody: 'Biểu mẫu đầy đủ sẽ được bổ sung theo nghiệp vụ.',
  },
  emptyState: {
    title: 'Thêm sản phẩm từ file excel',
    downloadTemplate: '(Tải về file mẫu: File đặt hàng nhập)',
    chooseFile: 'Chọn file dữ liệu',
    hint: 'Các cột: Mã hàng, Tên sản phẩm, Đơn vị tính, Đơn giá, Giảm giá, Số lượng. Mã hàng phải khớp với mã đã lưu trong hệ thống.',
    noSheet: 'File không chứa sheet dữ liệu.',
    noData: 'Không có dòng dữ liệu hợp lệ trong file.',
    importPartial: 'Đã nhập {success}/{total} dòng.',
    someUnmatched: '{count} dòng không tìm thấy mã hàng tương ứng.',
    allUnmatched: 'Không dòng nào khớp mã hàng (trên {total} dòng).',
  },
  detailTabs: {
    generalInfo: 'Thông tin chung',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
}
